import MainLayout from "@/components/layout/MainLayout.vue";
import PaymentList from "@/components/teacher/PaymentList.vue";
import VideoCourseList from "@/components/teacher/VideoCourseList.vue";
import { mapGetters } from "vuex";

export default {
    name: "paymentTab",
    components: {
        MainLayout,
        PaymentList,
        VideoCourseList,
    },

    data() {
        return {
            currentTab: "ClassPaymentList",
            tabs: ["ClassPaymentList", "CoursePaymentList"],
            classPaymentList:true,
            coursePaymentList:false,
        };
    },

    computed: {
        currentTabComponent: function () {
            return "tab-" + this.currentTab.toLowerCase();
        },

        ...mapGetters(["teacherId", "studentId", "userType"])
    },
    
    methods: {
        setActivePaymentTabName(name) {
            if (name == "ClassPaymentList") {
                this.classPaymentList = true;
                this.coursePaymentList = false;
            } else if (name == "CoursePaymentList") {
                this.classPaymentList = false;
                this.coursePaymentList = true;
            }
        },

        goClassPaymentList() {
            this.classPaymentList = true;
            this.coursePaymentList = false;
        },

        goVideoCoursePaymentList() {
            this.classPaymentList = false;
            this.coursePaymentList = true;
        }
    },

    mounted() {
    }
};
